<template>
  <AppHeader fixed>
    <SidebarToggler class="d-lg-none" display="md" mobile />
    <b-link v-if="role == 'admin'" class="navbar-brand" to="/">
      <img src="./../assets/tlogo.png" height="90%" width="auto" />
      <!-- <img class="navbar-brand-minimized" src="./../assets/logo.png" height="80%" width="auto" /> -->
      <!-- <span class="navbar-brand-full" style="font-size:16px;font-weight:500;color:black">Tusks</span> -->
    </b-link>
    <b-link v-else class="navbar-brand" to="/Reports" >
      <img src="./../assets/tlogo.png" height="90%" width="auto" />
    </b-link>
    <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
    <b-navbar-nav class="d-md-down-none">
      <!-- <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item> -->
      <!-- <b-nav-item class="px-3" to="/users" exact>Donors</b-nav-item> -->
      <!-- <b-nav-item class="px-3">Settings</b-nav-item> -->
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <AppHeaderDropdown right no-caret>
        <template slot="header">
          <div class="px-3">
            <img src="./../assets/user.png" class="img-avatar" />
          </div>
        </template>
        <template slot="dropdown">
          <b-dropdown-header tag="div" class="text-center">
            <strong>Settings</strong>
          </b-dropdown-header>
          <b-dropdown-item router-link to="/Profile">
            <i class="fa fa-user" /> Profile
          </b-dropdown-item>
          <b-dropdown-item router-link to="/changePassword">
            <i class="fa fa-pencil" /> Change Password
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="logout()">
            <i class="fa fa-lock" /> Logout
          </b-dropdown-item>
        </template>
      </AppHeaderDropdown>
    </b-navbar-nav>
    <!-- <AsideToggler class="d-none d-lg-block" />
    <AsideToggler class="d-lg-none" mobile />-->
  </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from "@coreui/vue";
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import store from "../store";

export default {
  name: "DefaultHeader",
  components: {
    AsideToggler,
    AppHeader,
    SidebarToggler,
    AppHeaderDropdown,
  },
  data() {
    return {
      role: localStorage.getItem("role")
    };
  },
  methods: {
    logout() {
      // axios({
      //   method: "GET",
      //   url: "/user/logout",
      //   headers: {
      //     "x-auth-token": localStorage.getItem("token"),
      //   },
      // });
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("usrType");
      store.commit("logoutUser");
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
<style>
.dropdown-item {
  min-width: 100% !important;
  max-width: 100% !important;
}
</style>